import { css } from '@emotion/react';
import { InsuranceType } from '@weave/schema-gen-ts/dist/schemas/insurance-verification/shared/enums.pb';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { SwitchChipGroup } from '@frontend/design-system';
import { getSwitchChipSelectedClassName } from '../utils/utils';

type InsuranceTypeChipsProps = {
  isEnhancedInsuranceVerificationEnabled: boolean;
  insuranceType: string;
  setInsuranceType: (type: InsuranceType) => void;
};

export const InsuranceTypeChips = ({
  isEnhancedInsuranceVerificationEnabled,
  insuranceType,
  setInsuranceType,
}: InsuranceTypeChipsProps) => {
  const { t } = useTranslation();
  if (!isEnhancedInsuranceVerificationEnabled) return null;
  return (
    <SwitchChipGroup
      css={switchChip}
      singleSelect
      defaultValue={insuranceType}
      setValue={(val) => {
        setInsuranceType(val.toString() as InsuranceType);
      }}
      value={[insuranceType]}
    >
      <SwitchChipGroup.Option
        className={getSwitchChipSelectedClassName(insuranceType, InsuranceType.INSURANCE_TYPE_PRIMARY)}
        value={InsuranceType.INSURANCE_TYPE_PRIMARY}
      >
        {t('Primary')}
      </SwitchChipGroup.Option>
      <SwitchChipGroup.Option
        className={getSwitchChipSelectedClassName(insuranceType, InsuranceType.INSURANCE_TYPE_SECONDARY)}
        value={InsuranceType.INSURANCE_TYPE_SECONDARY}
      >
        {t('Secondary')}
      </SwitchChipGroup.Option>
    </SwitchChipGroup>
  );
};

const switchChip = css`
  gap: ${theme.spacing(2)};
  margin-bottom: ${theme.spacing(2)};
  span {
    color: ${theme.colors.neutral90};
  }
  .selected,
  .selected:hover {
    background: ${theme.colors.primary5};
    border: solid 1px ${theme.colors.primary50};
  }
  .chip {
    :focus {
      outline: none;
    }
  }
`;
